module.exports = __webpack_public_path__ + "img/bg.a937cc55.png";